import { Calendar, MapPin, DollarSign, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function ScholarshipCard({ scholarship }) {
  return (
    <article className="border border-border/40 bg-card shadow-sm hover:shadow-md transition-all rounded-sm p-5" data-testid={`scholarship-card-${scholarship.scholarship_id}`}>
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h3 className="text-xl font-playfair font-bold text-foreground mb-2">{scholarship.title}</h3>
          <p className="text-sm text-muted-foreground mb-1">{scholarship.university}</p>
          <div className="flex items-center gap-1 text-sm text-muted-foreground">
            <MapPin size={14} />
            <span>{scholarship.country}</span>
          </div>
        </div>
        <div className="bg-accent/10 text-accent px-3 py-1 rounded-sm text-xs font-semibold">
          {scholarship.country}
        </div>
      </div>

      <p className="text-sm text-muted-foreground leading-relaxed mb-4 line-clamp-3">
        {scholarship.description}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
        <div className="border border-border/40 rounded-sm p-3">
          <div className="flex items-center gap-1 text-muted-foreground text-xs mb-1">
            <DollarSign size={14} />
            <span>Amount</span>
          </div>
          <div className="text-sm font-bold text-foreground">{scholarship.amount}</div>
        </div>
        <div className="border border-border/40 rounded-sm p-3">
          <div className="flex items-center gap-1 text-muted-foreground text-xs mb-1">
            <Calendar size={14} />
            <span>Deadline</span>
          </div>
          <div className="text-sm font-bold text-foreground">{scholarship.deadline}</div>
        </div>
      </div>

      <div className="bg-secondary rounded-sm p-3 mb-4">
        <div className="text-xs font-semibold text-secondary-foreground mb-1">Eligibility:</div>
        <div className="text-sm text-muted-foreground">{scholarship.eligibility}</div>
      </div>

      <Button
        className="w-full rounded-sm"
        onClick={() => window.open(scholarship.application_link, '_blank')}
        data-testid={`apply-${scholarship.scholarship_id}`}
      >
        <ExternalLink size={16} className="mr-2" />
        Apply Now
      </Button>
    </article>
  );
}